import React from 'react';

import { UiRichTextEditor } from '../../ui/ui-rich-text-editor';

import { richTextEditorConfig } from '../../util/ckeditor-config';

export class CkEditorFieldComponent extends React.PureComponent<ReduxFormFieldProps<string>> {
  changeDescription = (e: { editor: { getData: Function } }) => {
    const data = e.editor.getData();
    this.props.input.onChange(data);
  };

  render() {
    return (
      <UiRichTextEditor
        data={this.props.input.value || ''}
        onChange={this.changeDescription}
        config={richTextEditorConfig}
      />
    );
  }
}
